module.exports = __webpack_public_path__ + "img/selected3-min.227e80e4.png";